module.exports = __webpack_public_path__ + "static/media/IMG.LogText.a8fb70a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/Network/CompanyRegister/IMG.LogText.png
// module id = 6747
// module chunks = 0